import { highestAssignedSSR, highestAssignedUOS } from './highestAssigned';

// How many UOS panels and SSRs the form should show for a location it is about
// to load for editing.
//
// The server sends `uos_panel_number` and `ssr_quantity` as scalars, and the
// slice maps them through `|| null` — so an absent or zero count arrives as
// null. handleCreateUOSAndSSRList then loops `for (i = 1; i <= null; i++)`,
// which runs zero times, and the UOS and SSR dropdowns render empty on a site
// whose switch rows visibly carry UOS 01, 02, 03. The switch could not then be
// reassigned to a panel that plainly exists.
//
// The scalars are still authoritative when present and large enough: a panel
// with no switches on it yet is real but produces no switch row to count. So
// this raises the stored value to what the switches prove, and never lowers it.
// Same reasoning as counting switch panels rather than trusting
// `switches_number`.
//
// The floor comes from the same helper collectConfirmProblems refuses on, so a
// site repaired on the way in cannot be rejected on the way out.
export const derivePanelCounts = (switches, storedUOS, storedSSR) => {
  // Number(null) and Number('') are both 0, which is exactly the "missing"
  // case, so one coercion covers null, undefined, '' and 0 alike.
  const atLeast = (stored, derived) => {
    const best = Math.max(Number(stored) || 0, derived);
    return best > 0 ? best : '';
  };

  return {
    numOfUOS: atLeast(storedUOS, highestAssignedUOS(switches)),
    numOfSSR: atLeast(storedSSR, highestAssignedSSR(switches)),
  };
};

